// const moment = require('moment')

const formRows = [
  {
    span: 24,
    label: '标题',
    component: 'AInput',
    placeholder: '请输入标题',
    prop: 'title',
    allowClear: true
  },
  {
    span: 10,
    label: '文章类型',
    component: 'ASelect',
    prop: 'informationType',
    placeholder: '请选择文章类型',
    list: [
      { label: '行业资讯', value: '1' },
      { label: '政策制度', value: '2' },
      { label: '产业分析', value: '3' }
    ]
  },
  // {
  //   span: 10,
  //   label: '发布日期',
  //   component: 'ADate',
  //   placeholder: '请选择发布日期',
  //   prop: 'publishTime'
  // },
  {
    span: 24,
    label: '首图',
    component: 'AUpload',
    prop: 'picPath' // 首图
  },

  {
    span: 24,
    label: '附件',
    component: 'AUploadMultiple',
    prop: 'annexIds'
  },
  {
    span: 24,
    label: '内容',
    component: 'RichTextEdit',
    prop: 'content'
  }
]

const formRules = {
  title: [
    { required: true, message: '标题不能为空', trigger: 'blur' },
    { min: 1, max: 100, message: '输入的字数不能超过100个', trigger: 'blur' }
  ],
  informationType: [
    { required: true, message: '文章类型不能为空', trigger: 'blur' }
  ],
  content: [{ required: true, message: '内容不能为空', trigger: ['blur'] }]
  // picPath: [{ required: true, message: '首图不能为空', trigger: ['blur'] }]
  // publishTime: [
  //   { required: true, message: '发布日期不能为空', trigger: ['blur'] }
  // ]
}

const formInfo = [
  { label: '标题', value: '-', key: 'title' },
  { label: '文章类型', value: '-', key: 'informationTypeStr' },
  // { label: '发布日期', value: '-', key: 'publishTime' },
  { label: '首图', value: '-', key: 'picture', isVHtml: true },
  { label: '内容', value: '-', key: 'content', isVHtml: true },
  { label: '附件', value: '-', key: 'annex', isVHtml: true }
]

module.exports = {
  formRows,
  formRules,
  formInfo
}
